import { Skeleton } from '@/components/ui/skeleton';

export function CtaCalendarActionSkeleton() {
  return (
    <div className='flex w-fit space-x-4'>
      <Skeleton className='h-9 w-48' />
      <Skeleton className='h-9 w-10' />
    </div>
  );
}
